import { render, staticRenderFns } from "./EmployeeSetup.vue?vue&type=template&id=1fea138e&"
import script from "./EmployeeSetup.vue?vue&type=script&lang=js&"
export * from "./EmployeeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports